import { ALERT_SEVERITY, ERROR_MESSAGES, ROLE_TYPE } from 'eebac/constants';
import { Catch } from '../api_exception';
import { setGlobalMessage, setLoading } from '../app';
const BASE_PATH = 'VENDOR_DASHBOARD';

export const SET_DASHBOARD_DATA = `${BASE_PATH}/SET_DASHBOARD_DATA`;

export const loadVendorDashboardData = () =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        dispatch(setDashboardData({
            totalPosts: "",
            appliedPosts: "",
            rfqs: "",
            meetingInvites: ""
        }));

        client.get('/vendor/dashboard').
            then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.dashboard) {
                    dispatch(setDashboardData(result.data.dashboard));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const setDashboardData = (data) => ({
    type: SET_DASHBOARD_DATA,
    data
});

const initialState = {
    totalPosts: "",
    appliedPosts: "",
    rfqs: "",
    meetingInvites: ""
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_DASHBOARD_DATA:
            return {
                ...state,
                totalPosts: action.data.totalPosts,
                appliedPosts: action.data.appliedPosts,
                rfqs: action.data.rfqs,
                meetingInvites: action.data.meetingInvites
            }
    }
    return state;
}